import styled, { css } from "styled-components";

import { Typography } from "@material-ui/core";

import { COLORS } from "constants/colorScheme";

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LogoWrapper = styled.div`
  ${({ withText }: { withText?: boolean }) =>
    withText &&
    css`
      margin-bottom: 4px;
    `};
`;

export const LogoText = styled(Typography)`
  color: ${COLORS.CYAN};
`;
